import { IconType } from 'react-icons';

export const ColibriIcon: IconType = (props) => (
  <svg
    {...props}
    id="Camada_1"
    data-name="Camada 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 684.01 537.96"
  >
    <defs>
      <clipPath id="clippath-1">
        <path
          fill="currentColor"
          d="M353.03,345.51C317.99,435.89,97.33,513.25,0,537.96c297.04-39.65,398.32-145.74,390.8-200.48-4.26-31.06-20.92-36.66-74.95-72.62-15.62-10.39-29.54-17.87-35.96-27.73-9.55-14.68-7.28-30.67-8.35-37.48-.12,2.99-8.31,21.02,0,39.91,8.31,18.89,13.53,18.18,62.38,63.58,24.27,31.59,20.27,39.31,19.1,42.35Z"
        />
      </clipPath>
      <clipPath id="clippath-4">
        <path
          fill="currentColor"
          d="M258.37,141.47l-142.79,52.3,160.26-35.95,19.1-20.31c27.87-25.02,55.01,15.74,65.2,39.61l1.53-35.65c1.22-32.91-28.33-43.27-49.05-39.41-16.58,3.09-43.06,27.56-54.24,39.41Z"
        />
      </clipPath>
    </defs>
    <path
      fill="currentColor"
      d="M413.35,266.49l-27.02-25.49c10.96-2.44,160.59-73.33,216.83-109.99-44.77,56.14-145.2,113.71-189.81,135.48Z"
    />
    <g>
      <path
        fill="currentColor"
        d="M353.03,345.51C317.99,435.89,97.33,513.25,0,537.96c297.04-39.65,398.32-145.74,390.8-200.48-4.26-31.06-20.92-36.66-74.95-72.62-15.62-10.39-29.54-17.87-35.96-27.73-9.55-14.68-7.28-30.67-8.35-37.48-.12,2.99-8.31,21.02,0,39.91,8.31,18.89,13.53,18.18,62.38,63.58,24.27,31.59,20.27,39.31,19.1,42.35Z"
      />
      <g clipPath="url(#clippath-1)">
        <path
          fill="currentColor"
          d="M0,538.01h397.67v-1.56H0v1.56ZM0,536.45h397.67V200.16H0v336.29Z"
        />
      </g>
    </g>
    <path
      fill="currentColor"
      d="M610.17,92.62c29.66-17.25,55.56-38.59,73.84-47.94-17.57,5.59-58.89,25.95-96.18,43.57-122.28,57.79-183.09,59.78-226.48,60.33l-1.22,28.44c69.57,0,161.36-32.8,250.04-84.4Z"
    />
    <g>
      <path
        fill="currentColor"
        d="M258.37,141.47l-142.79,52.3,160.26-35.95,19.1-20.31c27.87-25.02,55.01,15.74,65.2,39.61l1.53-35.65c1.22-32.91-28.33-43.27-49.05-39.41-16.58,3.09-43.06,27.56-54.24,39.41Z"
      />
      <g clipPath="url(#clippath-4)">
        <path
          fill="currentColor"
          d="M361.79,98.41v95.38h1.02v-95.38h-1.02ZM115.48,98.41v95.38h.19v-95.38h-.19ZM115.68,98.41v95.38h246.12v-95.38H115.68Z"
        />
      </g>
    </g>
    <path
      fill="currentColor"
      d="M255.12,137.61C191.58,110.23,161.89,34.46,154.98,0c37.21,70.28,95.94,108.87,119.65,117.91l-19.5,19.7"
    />
  </svg>
);
